import type { Locale } from "@/lib/i18n";
import { pl, type WPathTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

/**
 * WPath translations — scoped per-locale.
 *
 * Consume w komponencie przez `useT(wPathTranslations)`:
 *   const t = useT(wPathTranslations);
 *   t.ariaLabel // -> "Ścieżka nawigacji" (pl) | "Breadcrumb" (en) | ...
 */
export const wPathTranslations: Record<Locale, WPathTranslations> = {
  pl,
  en,
  de,
};

export type { WPathTranslations };
